export const PROFILE_ACCOUNT = 'account';
export const PROFILE_AVAILABLE_DESCRIPTORS = 'available_descriptors';
export const PROFILE_BOOST = 'boost';
export const PROFILE_BOUNCER_BYPASS = 'bouncerbypass';
export const PROFILE_CONTACT_CARDS = 'contact_cards';
export const PROFILE_EMAIL_SETTINGS = 'email_settings';
export const PROFILE_FEATURE_ACCESS = 'feature_access';
export const PROFILE_INSTAGRAM = 'instagram';
export const PROFILE_LIKES = 'likes';
export const PROFILE_METER = 'profile_meter';
export const PROFILE_NOTIFICATIONS = 'notifications';
export const PROFILE_OFFERINGS = 'offerings';
export const PROFILE_ONBOARDING = 'onboarding';
export const PROFILE_MISC_MERCHANDISING = 'misc_merchandising';
export const PROFILE_PAYWALLS = 'paywalls'; // pass to profile v2 when backend enables paywalls on web
export const PROFILE_PLUS_CONTROL = 'plus_control';
export const PROFILE_PURCHASE = 'purchase';
export const PROFILE_READ_RECEIPTS = 'readreceipts';
export const PROFILE_SPOTIFY = 'spotify';
export const PROFILE_SUPER_LIKES = 'super_likes';
export const PROFILE_TINDER_U = 'tinder_u';
export const PROFILE_TRAVEL = 'travel';
export const PROFILE_TUTORIALS = 'tutorials';
export const PROFILE_USER = 'user';
export const PROFILE_ALL_IN_GENDER = 'all_in_gender';

export const PROFILE_V2_FIELDS = [
  PROFILE_ACCOUNT,
  PROFILE_AVAILABLE_DESCRIPTORS,
  PROFILE_BOOST,
  PROFILE_BOUNCER_BYPASS,
  PROFILE_CONTACT_CARDS,
  PROFILE_EMAIL_SETTINGS,
  PROFILE_FEATURE_ACCESS,
  PROFILE_INSTAGRAM,
  PROFILE_LIKES,
  PROFILE_METER,
  PROFILE_NOTIFICATIONS,
  PROFILE_MISC_MERCHANDISING,
  PROFILE_OFFERINGS,
  PROFILE_ONBOARDING,
  PROFILE_PAYWALLS,
  PROFILE_PLUS_CONTROL,
  PROFILE_PURCHASE,
  PROFILE_READ_RECEIPTS,
  PROFILE_SPOTIFY,
  PROFILE_SUPER_LIKES,
  PROFILE_TINDER_U,
  PROFILE_TRAVEL,
  PROFILE_TUTORIALS,
  PROFILE_USER,
  PROFILE_ALL_IN_GENDER,
];

export const PROFILE_V2_MAX_RETRY_COUNT = 3;
export const PROFILE_V2_RETRY_INTERVAL = 3000;

export type ValidProfileFields = (typeof PROFILE_V2_FIELDS)[number] | typeof PROFILE_PAYWALLS;
